import { reportError } from '@/core/lib/utils/report-error'

export interface ILogService {
  message(message: unknown, context?: unknown): void
  warn(message: unknown, context?: unknown): void
  error(error: unknown | Error, context?: unknown): Promise<void>
}

export const createLogService = (): ILogService => {
  const isProd = process.env.NODE_ENV === 'production'

  return {
    message(msg, context) {
      if (isProd) {
        return
      }
      console.log('[INFO]', msg, context ?? '')
    },
    warn(msg, context) {
      if (isProd) {
        return
      }
      console.warn('[WARN]', msg, context ?? '')
    },
    async error(err, context) {
      await reportError(err)
      if (isProd) {
        return
      }
      if (err instanceof Error) {
        console.warn('[ERROR]', err.message, err.stack, context ?? '')
      } else {
        console.warn('[ERROR]', err, context ?? '')
      }
    },
  }
}
